import { useEffect } from 'react'

/**
 * Adds a robots noindex/nofollow meta tag while an internal screen is mounted so
 * the dashboard never shows up in search results or link previews.
 */
export function useNoIndex(): void {
  useEffect(() => {
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex, nofollow, noarchive, nosnippet'
    document.head.appendChild(meta)
    return () => {
      document.head.removeChild(meta)
    }
  }, [])
}
